import { observer } from "mobx-react-lite";
import React, { MutableRefObject, PropsWithChildren, useEffect, useState, useRef } from 'react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
//import dxTabPanel from "devextreme/ui/tab_panel";
import { useAuthStore } from "../hooks/useAuthStore";
import { routesTabs } from "../router/routerTabs";
import ReportView from "./ReportView";
import MultiView from 'devextreme-react/multi-view';
const MainTabs = ({ dataSource}) => {
    const authStore = useAuthStore();
    const afterInsert = authStore.storage["afterInsertToBuildedReports"];
    let ref = useRef(null);
//    const tabPanelInstance = (aref): dxTabPanel => {
    const tabPanelInstance = (aref) => {
        let tabPanel = aref.current;
        if (tabPanel) {
//            let instance: dxTabPanel | null = tabPanel.instance;
            let instance = tabPanel.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }

    const onInitialized = (args) => {
        let comp = args.component;// as dxTabPanel;
        comp.option("selectedIndex", 0);
//        doAfterInsert(comp.option("selectedItem"));
    }

    const currItems = () => {
        let items = [];
//        const instance: dxTabPanel = tabPanelInstance(ref);
        const instance = tabPanelInstance(ref);
        if (instance) {
            items = instance.option("items");
        }
        return items;
    }

    authStore.storage["setMainTabsSelectedIndex"] = (selectedIndex) => {
//        const instance: dxTabPanel = tabPanelInstance(ref);
        const instance = tabPanelInstance(ref);
        if (instance) {
            instance.option("selectedIndex", selectedIndex);
        }
    }
    authStore.storage["setMainTabsSelectedItem"] = (selectedItem) => {
        //        const instance: dxTabPanel = tabPanelInstance(ref);
        const instance = tabPanelInstance(ref);
        if (instance) {
            instance.option("selectedItem", selectedItem);
        }
    }

    const doAfterInsert = (newItem) => {
        if (afterInsert) {
            const delay = (ms) => {
                return new Promise(resolve => setTimeout(() => { }, ms));
            }
            setTimeout(() => {
                afterInsert(newItem);
            }, 400);
        }
    }

    useEffect(
        () => {
            authStore.storage["addTabForReportView"] = async (reportTitle, reportId) => {
                //        const instance: dxTabPanel = tabPanelInstance(ref);
                const instance = tabPanelInstance(ref);
                if (instance) {
                    let now = new Date();
                    let ticks = now.getTime();

//                    tabsListStore.push
                    let newItem = {
                        id: ticks,
                        title: reportTitle,
                        text: reportTitle,
                        componentJSX: <ReportView reportId={reportId} />,
                        fixedTab: false
                    };
                    dataSource.store().insert(newItem);

/*
                    dataSource.store().push
                        ([{
                        type: 'insert',
                        key: ticks,
                            data: newItem,
                        }]);
//                    dataSource.reload();
*/
                    doAfterInsert(newItem);
                }
            }


        }, []);
    const itemTemplate = (props) => {
        if (props && props.data && props.data.componentJSX) {
            return props.data.componentJSX
        }
        else {
            return (<div> {props.data.title} </div>);
        }
    }


    return (
        <div className="main-tabs-container"
        >
            <TabPanel
                elementAttr={{ class: "main-tabpanel" }}
                ref={ref}
                deferRendering={false}
                repaintChangesOnly={true}
                //                onInitialized={onInitialized}
                dataSource={dataSource}
                itemComponent={itemTemplate}
                showNavButtons={true}
                swipeEnabled={false}
            >            
            </TabPanel>
        </div>

    )


}
export default MainTabs;
